import { useState, useEffect, useCallback } from 'react';
import { seatTypesService } from '../../shared/services/seatTypesService';

export const useSeatTypes = (eventId = null) => {
  const [seatTypes, setSeatTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSeatTypes = useCallback(async () => {
    if (!eventId) return;

    setLoading(true);
    setError(null);

    try {
      const data = await seatTypesService.getSeatTypesByEvent(eventId);
      
      const sortedData = data.sort((a, b) => {
        if (a.priority !== b.priority) {
          return a.priority - b.priority;
        }
        return a.type.localeCompare(b.type);
      });
      
      setSeatTypes(sortedData);
    } catch (err) {
      setError(err.message || 'Error al cargar tipos de asientos');
      
      // Si no hay tipos de asientos para este evento, intentar crear los por defecto
      if (err.message?.includes('404') || err.message?.includes('not found')) {
        try {
          const defaultTypes = await seatTypesService.createDefaultSeatTypes(eventId);
          setSeatTypes(defaultTypes);
          setError(null);
        } catch (defaultErr) {
          setError('No se pudieron crear los tipos de asientos por defecto');
        }
      }
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    fetchSeatTypes();
  }, [fetchSeatTypes]);

  const refetch = useCallback(() => {
    fetchSeatTypes();
  }, [fetchSeatTypes]);

  const createDefaults = useCallback(async () => {
    if (!eventId) return;
    
    setLoading(true);
    try {
      const defaultTypes = await seatTypesService.createDefaultSeatTypes(eventId);
      setSeatTypes(defaultTypes);
      setError(null);
    } catch (err) {
      setError(err.message || 'Error al crear tipos por defecto');
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  return {
    seatTypes,
    loading,
    error,
    refetch,
    createDefaults,
  };
}; 